import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    tableRow: {
        flexDirection: "row",
        alignItems: "center",
        ...webStyle({
            transition: "all 0.2s ease-in-out",
            cursor: "pointer"
        })
    },
    colContact: {
        justifyContent: "center",
        flex: 3
    },
    colSector: {
        justifyContent: "center",
        flex: 2
    },
    colDate: {
        justifyContent: "center",
        flex: 2
    },
    colStatus: {
        justifyContent: "center",
        flex: 1
    },
    colActions: {
        justifyContent: "center",
        alignItems: "center",
        width: 50
    },
    avatarPlaceholder: {
        justifyContent: "center",
        alignItems: "center",
        height: 40,
        width: 40
    },
    colUser: {
        flexDirection: "row",
        alignItems: "center",
        flex: 2
    },
    companyContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    avatarImage: {
        height: 40,
        width: 40
    },
    companyLogo: {
        height: 32,
        width: 32
    }
});

export default stylesheet;
